module.exports = __webpack_public_path__ + "static/naturalist-03-614c534b89199011a905f7db0c5d885c.png";